var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-main", { attrs: { id: "register-alternate" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        attrs: { id: "acceptance-form" },
      },
      [
        _vm.errorMessage
          ? _c("div", { attrs: { id: "nomination-error" } }, [
              _c("h3", [_vm._v("Sorry, we have encountered an error.")]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.errorMessage))]),
              _vm._v(" "),
              _c("p", [
                _vm._v("Please call head office on "),
                _c(
                  "a",
                  { staticClass: "tel", attrs: { href: "tel:0263560300" } },
                  [_vm._v("02 6356 0300")]
                ),
                _vm._v(" for further details."),
              ]),
            ])
          : [
              _c("p", [
                _c("strong", [_vm._v(_vm._s(_vm.nominee.fullName))]),
                _vm._v(
                  ", please confirm or decline your registration as an alternate for the\n        delegate below."
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-card",
                {
                  staticClass: "person-details",
                  attrs: { id: "delegate-details", shadow: "never" },
                },
                [
                  _c("h4", [_vm._v("Delegate details")]),
                  _vm._v(" "),
                  _c("h3", [_vm._v(_vm._s(_vm.delegate.fullName))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.branch))]),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "submit" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "info",
                        plain: "",
                        disabled: !_vm.delegate.fullName,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.sendResponse(false)
                        },
                      },
                    },
                    [_vm._v("\n          Decline\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        disabled: !_vm.delegate.fullName,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.sendResponse(true)
                        },
                      },
                    },
                    [_vm._v("\n          Accept\n        ")]
                  ),
                ],
                1
              ),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }